import type { ElementType, ReactNode } from "react";

import { Icon } from "@core/components/Icon";

import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { ChevronUpIcon } from "@jti/brand-icons/chevron-up";

import styles from "./CardHeader.module.scss";

export type CardHeaderProps = {
  title?: string;
  titleAs?: ElementType;
  description?: string;
  headerContent?: ReactNode;
  isCollapsible: boolean;
  isCollapsed: boolean;
  contentId: string;
  onToggle: () => void;
  collapseButtonAriaLabel?: string;
};

export const CardHeader = ({
  title,
  titleAs: TitleTag = "h3",
  description,
  headerContent,
  isCollapsible,
  isCollapsed,
  contentId,
  onToggle,
  collapseButtonAriaLabel,
}: CardHeaderProps) => {
  const titleSection =
    title || headerContent || isCollapsible ? (
      <div className={styles.titleRow}>
        {title && <TitleTag className={styles.title}>{title}</TitleTag>}
        {headerContent && <div className={styles.actions}>{headerContent}</div>}
        {isCollapsible && <Icon icon={isCollapsed ? ChevronDownIcon : ChevronUpIcon} />}
      </div>
    ) : null;

  const descriptionSection = description && <p className={styles.description}>{description}</p>;
  if (isCollapsible) {
    return (
      <div className={styles.header}>
        <button
          type="button"
          className={styles.headerButton}
          onClick={onToggle}
          aria-expanded={!isCollapsed}
          aria-controls={contentId}
          aria-label={!title && !description ? collapseButtonAriaLabel : undefined}
        >
          {titleSection}
          {descriptionSection}
        </button>
      </div>
    );
  }

  return (
    <div className={styles.header}>
      {titleSection}
      {descriptionSection}
    </div>
  );
};
